import { Component, EventEmitter, ViewEncapsulation, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { AlertsComponent, ModalSteps } from '@shopping-angular-components/alerts';
import { AlertsWordings } from '@shopping-angular-components/alerts/lib/alerts/alerts-wordings.model';
import { Subscription } from 'rxjs';


@Component({
    selector: 'alerts-sac-modal',
    template: `
        <alerts-component
            [product]="product"
            [flow]="flow"
            [showModal]="showModal"
            [locale]="locale"
            [cityName]="cityName"
            [mail]="mail"
            [isMobile]="isMobile"
            [webView]="webView"
            [toastMode]="toastMode"
            [createWithoutEmail]="createWithoutEmail"
            [isWl]="isWl"
            [showToastActivateNotification]="showToastActivateNotification"
            [xClient]="'nymeria'"
            [(showModal)]="showModal"
            [wordings]="wordings"
            [data]="data">
        </alerts-component>
    `,
    encapsulation: ViewEncapsulation.None
})
export class AlertsSacModalComponent implements OnInit, OnDestroy {
    @Input() isMobile: boolean;
    @Input() product: string;
    @Input() flow: string;

    static openAlertsModal: EventEmitter<any> = new EventEmitter();

    currentStep: ModalSteps = ModalSteps.INPUT;
    locale: string;
    cityName: string;
    mail: string;
    webView: boolean;
    toastMode: boolean;
    createWithoutEmail: boolean;
    isWl: boolean;
    showToastActivateNotification: boolean;
    data: any;
    showModal: boolean;
    wordings: AlertsWordings;

    protected _eventSubscriptions: Subscription[] = [];

    constructor(private translateService: TranslateService) {

        const openAlertsModalSubscription: Subscription = AlertsSacModalComponent.openAlertsModal.subscribe((args:any) => {
            if (args && args === "error") {
                this.showErrorModal();
                return;
            }
            this.emitCreateAlertForced(args)
        })
        this._eventSubscriptions.push(openAlertsModalSubscription);
    }

    ngOnInit(): void {
        
        this.wordings = {
            "alerta.activated.edit": this.translateService.instant('alerts.alerta.activated.edit'),
            "see.alerts": this.translateService.instant('alerts.see.alerts'),
            "alert.activated.error": this.translateService.instant('alerts.alert.activated.error'), 
        }
        const closeAlertsModalSubscription: Subscription = AlertsComponent.dispatchEvent.subscribe(any=> {
            if (any.type === 'close') {
                this.closeModal();
            }
        })
        this._eventSubscriptions.push(closeAlertsModalSubscription);
    }

    ngOnDestroy(): void {
        this._eventSubscriptions.forEach(sub => sub.unsubscribe());
    } 

    private emitCreateAlertForced(args: any):void {
        this.flow = args.flow;
        this.locale = args.locale;
        this.mail = args.mail;
        this.cityName = args.cityName;
        this.data = args.data;
        this.webView = args.webView;
        this.toastMode = args.toastMode;
        this.createWithoutEmail = args.createWithoutEmail;
        this.isWl = args.isWl;
        this.showToastActivateNotification = args.showToastActivateNotification;

        AlertsComponent.createAlertForced.emit(args);
    }

    public showErrorModal():void {
        this.showModal = false; // Primero lo cerramos para que se reinicie el timeout
        this.currentStep = ModalSteps.ERROR;
        this.showModal = true;
    }

    private closeModal():void {
        this.showModal = false;
    }
}
